"use client";

import ShoppingBag from "@mui/icons-material/ShoppingBag"; // Local CUSTOM COMPONENTS
import { Fragment } from "react";

import SalifyFallback from "src/lib/components/salify-fallback/default";
import DashboardHeader from "../../dashboard-header"; // CUSTOM DATA MODEL
import OrderProgress from "../order-progress";
import OrderSummery from "../order-summery";
import OrderedProducts from "../ordered-products";

// =============================================================
const OrderDetailsPageView = (props) => {
  const order = SalifyFallback.useSelect("output:order.data");

  if (!order) {
    return null;
  }

  return (
    <Fragment>
      {/* TITLE HEADER AREA */}
      <SalifyFallback.Label
        path="Order Details"
        default="Chi tiết đơn hàng"
        render={(label) => (
          <SalifyFallback.Label
            path="Order Again"
            default="Tạo lại order"
            render={(againLabel) => (
              <DashboardHeader
                href="/orders"
                Icon={ShoppingBag}
                title={label}
                // buttonText={againLabel}
              />
            )}
          />
        )}
      />

      {/* ORDER PROGRESS AREA */}
      <OrderProgress />

      {/* ORDERED PRODUCT LIST */}
      <OrderedProducts order={order} />

      {/* SHIPPING AND ORDER SUMMERY */}
      <OrderSummery order={order} />
    </Fragment>
  );
};

export default OrderDetailsPageView;
